import React from 'react';
import { Trans } from 'react-i18next';
import useLanguagesHooks from '../../../../../../../../../Components/Languages/setLanguage-hooks';
import Button from '../../../../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../../../../Interfaces/componentTypes';
import { Trash } from '../../../../../../../../../Assets/Icons';
import styles from './deleteUnitDialog.module.scss';

interface IDeleteUnitDialogProps {
    unitTitle: string;
    onDelete: () => void;
    onClose: () => void;
}

const DeleteUnitDialog: React.FC<IDeleteUnitDialogProps> = ({
    unitTitle,
    onDelete,
    onClose,
}) => {
    const { t } = useLanguagesHooks();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={Trash} alt='trash.svg' />
                <p>{t('My_Business.My_Services.Dine_In.Delete_Unit.Header')}</p>
            </div>
            <div className={styles.content}>
                <div className={styles.text}>
                    <Trans
                        i18nKey="My_Business.My_Services.Dine_In.Delete_Unit.Remove_Text"
                        values={{ title: unitTitle }}
                        components={{
                            strong: <span className={styles.unitTitle} />,
                        }}
                    />
                </div>
                <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Cancel')}
                        type='button'
                        onClick={onClose}
                        buttonStyle={styles.button}
                    />
                    <Button
                        buttonType={ButtonTypes.Primery}
                        title={t('Buttons.Delete')}
                        type='button'
                        onClick={onDelete}
                        buttonStyle={styles.button}
                    />
                </div>
            </div>
        </div>
    );
};

export default DeleteUnitDialog;
